import { WoBaseModel } from './wo-base-model';

export class ExportShuttle extends WoBaseModel {
  overHeight = false;
  overWeight = false;
  haz = false;
  houseBillOfLading = '';
  poNumber = '';
  containerNumber = '';
  containerSize = '40ST';
  containerType = 'DRY';
  erd = '';
  cutOff = '';
  freeDays = null;
  freeDaysType = 'Calendar';
  seal = '';
  commodity = '';
  quantity = null;
  unit = 'Unit';
  shippingLine = '';
  chassisNumber = '';
  pulloutChassisNumber = '';
  chassisPool = '';
  bondEntry = '';
  cf = '';
  dropLive = 'DROP';
  bookingNumber = '';
  wms = false;
  tare = '';
  streetTurn = '';
  returnFreeDay = '';
}
